var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOoos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 84,
    viewBox: "0 0 216 84",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.909 18.866C121.894 15.52 116.688 13.5 111 13.5c-12.703 0-23 10.074-23 22.5s10.297 22.5 23 22.5 23-10.074 23-22.5c0-3.2-.683-6.244-1.914-9H183a7 7 0 0 1 0 14h22a7 7 0 0 1 0 14h-19a7 7 0 0 0 0 14h6a7 7 0 0 1 0 14h-52a7.026 7.026 0 0 1-1.5-.161A7.026 7.026 0 0 1 137 83H46a7 7 0 0 1 0-14H7a7 7 0 0 1 0-14h40a7 7 0 0 0 0-14H22a7 7 0 0 1 0-14h40a7 7 0 0 1 0-14h57c3.48 0 6.367 2.54 6.909 5.866ZM209 83a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61 1)",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 34.5,
    rx: 23,
    ry: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.854 66.845c-4.903 3.323-9.05 4.836-12.439 4.539-6.036-.528-8.17-7.263-14.71-7.835-3.318-.29-6.802 1.587-10.453 5.633M94.725 69.212c-4.564.417-5.081-3.25-9.11-3.603-1.373-.12-2.782.178-4.229.894-.471.234-1.188.685-2.15 1.353-1.017.882-1.765 1.404-2.242 1.569-1.85.637-3.325.222-4.163.05-.732-.15-1.95-.685-3.651-1.605-.668-.36-1.837-1.035-3.507-2.022-1.355-.554-2.676-.538-3.962.047-1.287.585-2.76 1.84-4.422 3.766M62 80.377c-3.532 2.01-5.685.881-6.953 0C52.338 78.494 50 75.5 47.243 75.5c-3.201 0-6.282 1.626-9.243 4.877M50 6.071V.93M78.703 34.125l6.516-.227M13.507 35.057l6.516-.228M66.826 12.282l4.19-4.996M69.41 56.864l4.61 4.613M32.83 11.35l-4.19-4.996M30.246 56.864l-4.61 4.613M22.293 21.81l-5.468-3.552M22.293 45.28l-5.468 3.553M76.433 45.28l5.468 3.553M76.433 22.742 81.9 19.19",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOoos);
export default __webpack_public_path__ + "static/media/ooos.1619f0be6dc785d360f99e874ee2852a.svg";
export { ForwardRef as ReactComponent };